<template>
    <section class="module-small bg-dark galleryBackground" id="features"> 
       <div class="container">
           <div class="row" style="padding-bottom: 5%;">
              <div class="col-sm-offset-4 col-sm-4 story-title col-xs-12">
               <img v-lazy="imgUrl1" alt="dwerve">
              </div>
            </div> 
        </div>
        <ul class="feature-list">
            <div class="feature-wrapper">
                <div class="feature-row">
                  <li><img v-lazy="imgUrl2" alt="dwerve"><span>Fight with Turrets and Traps</span>  to spill the guts of dwarf-thirsty monsters and bosses</li>
                  <li><img v-lazy="imgUrl3" alt="dwerve"> <span>Explore Ancient Dungeons</span>  to unravel the history of the dwarfs and trolls</li>
                    
                    
                </div>
                
            </div>
            <div class="feature-wrapper">
                <div class="feature-row">
                    <!-- <li><span>Collect Runic Blueprints</span>  to unlock dozens of troll-slaying turrets and traps</li> -->
                     <li><img v-lazy="imgUrl4" alt="dwerve"><span>Upgrade your Arsenal </span> of lethal contraptions, each with its own unique skill tree</li>
         
                    <li><img v-lazy="imgUrl5" alt="dwerve"><span>Story-Based Campaign</span>  with rich dialogue, diverse characters, and unpredictable plot</li>
                </div>
            </div>
             <div class="feature-wrapper">
                <div class="feature-row">
                             <li><img v-lazy="imgUrl6" alt="dwerve"><span>Discover Powerful Artifacts</span> that give you special abilities to fight and outmaneuver foes</li>
                 
                    <li><img v-lazy="imgUrl7" alt="dwerve"><span>Complete Daring Quests</span>  on your adventure into the depths  of the dungeons</li>
                    
                </div>
             </div>
        </ul>
        <div class="gif-wrapper" v-if="!isMobile()">
          <div class="all-gifs">
            <div class="three-col">
              <img v-lazy="imgUrl15" alt="">
              <img v-lazy="imgUrl16" alt="">
              <img v-lazy="imgUrl17" alt="">
              <img v-lazy="imgUrl18" alt="">
              <img v-lazy="imgUrl19" alt="">
              <img v-lazy="imgUrl20" alt="">
              <img v-lazy="imgUrl21" alt="">
               <img v-lazy="imgUrl22" alt="">
              <img v-lazy="imgUrl23" alt="">
            </div>
          </div>
        </div>
       
    </section>
</template>

<script>

export default {
  data: function() {
    return {
      imgUrl1: '/static/assets/images/Features3.png',
      imgUrl2: '/static/assets/images/wolf-trap.svg',
      imgUrl3: '/static/assets/images/dungeon-gate.svg',
      imgUrl4: '/static/assets/images/armor-upgrade.svg',
      imgUrl5: '/static/assets/images/book-cover.svg',
      imgUrl6: '/static/assets/images/all-for-one.svg',
      imgUrl7: '/static/assets/images/tied-scroll.svg',
      imgUrl8: '/static/assets/images/feature-fallback2.png',
      imgUrl9: '/static/assets/images/feature-fallback3.png',
      imgUrl10: '/static/assets/images/feature-fallback4.png',
      imgUrl11: '/static/assets/images/feature-fallback5.png',
      imgUrl12: '/static/assets/images/feature-fallback6.png',
      imgUrl13: '/static/assets/images/feature-fallback7.png',
      imgUrl14: '/static/assets/images/feature-fallback8.png',

      imgUrl15: '/static/assets/images/Dwerve-GIF-Workbench.gif',
      imgUrl16: '/static/assets/images/Dwerve-GIF-Snoring-Forest.gif',
      imgUrl17: '/static/assets/images/Dwerve-GIF-Magma-Mines.gif',
      imgUrl18: '/static/assets/images/Dwerve-GIF-Hall-of-Heroes.gif',
      imgUrl19: '/static/assets/images/Dwerve-GIF-Grombil.gif',
      imgUrl20: '/static/assets/images/Dwerve-GIF-Dialog.gif',
      imgUrl21: '/static/assets/images/Dwerve-GIF-Crystal-Caves.gif',
      imgUrl22: '/static/assets/images/Dwerve-GIF-Cliff-View.gif',
      imgUrl23: '/static/assets/images/Dwerve-GIF-Ancient-Ruins.gif',

    };
  },
  methods: {
   isMobile() {
    if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      return true
    } else {
      return false
    }
  }
  },
  mounted() {
  }
};

</script>

<style scoped>
ul.feature-list {
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
        display: flex;
    list-style-type: none;
    /* list-style-image: url(/static/assets/images/gem.png); */
}
ul.feature-list li {
    font-family: Grandmaster;
    font-size: 15px;
    padding-bottom: 20px;
    color: #fff;
    text-align: center;
}
ul.feature-list li span {
    font-size: 18px;
    display: block;
    color: #28a9ff;
}
.feature-video {
    width: 33%;
    padding: 10px;
    display: inline-block;
}
ul.feature-list li img {
    max-width: 74px;
    filter: drop-shadow(0 0 0.75rem #5fc3db);
    padding-bottom: 15px;
}
.feature-row {
    padding-right: 20px;
    display: inline-block;
}
.vid-wrap {
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
}
.story-text {
  text-align: center;
  font-size: 60px;
  color: #121519;
  font-family: Digitalt;
}
video {
    display: block;
    box-shadow: 10px 10px 5px 0px rgba(0,0,0,0.75);
}
.feature-wrapper {
    width: 33%;
    display: inline-block;
    margin-bottom: 40px;
}
.story-title {
  background-repeat: no-repeat;
  background-position: center;
  text-align: center;
  background-size: contain;
}

.hr-pattern-top {
  margin-bottom: 80px;
  margin-top: 8px;
  border: 18px dashed #999999a3;
}
.galleryBackground {
  background: url("/static/assets/images/Dwerve-Brick-Texture.png");
  padding-bottom: 68px;
}
.col-sm-4.col-xs-8 {
    padding: 20px;
}
.cta-title span {
    display: block;
    font-size: 13px;
    padding-top: 5px;
    color: #28aaff;
}

.cta-title {
  font-family: Grandmaster;
  font-size: 20px;
  text-align: center;
  margin-top: 0px;
  text-shadow: -2.4px -2.4px 0 #282e35, -2.4px -1.4px 0 #282e35,
    -2.4px -0.4px 0 #282e35, -2.4px 0.6px 0 #282e35, -2.4px 1.6px 0 #1d1a44,
    -2.4px 2.6px 0 #282e35, -1.4px -2.4px 0 #282e35, -1.4px -1.4px 0 #282e35,
    -1.4px -0.4px 0 #282e35, -1.4px 0.6px 0 #282e35, -1.4px 1.6px 0 #282e35,
    -1.4px 2.6px 0 #282e35, -0.4px -2.4px 0 #282e35, -0.4px -1.4px 0 #282e35,
    -0.4px -0.4px 0 #282e35, -0.4px 0.6px 0 #282e35, -0.4px 1.6px 0 #282e35,
    -0.4px 2.6px 0 #282e35, 0.6px -2.4px 0 #282e35, 0.6px -1.4px 0 #282e35,
    0.6px -0.4px 0 #282e35, 0.6px 0.6px 0 #282e35, 0.6px 1.6px 0 #282e35,
    0.6px 2.6px 0 #282e35, 1.6px -2.4px 0 #282e35, 1.6px -1.4px 0 #282e35,
    1.6px -0.4px 0 #282e35, 1.6px 0.6px 0 #282e35, 1.6px 1.6px 0 #282e35,
    1.6px 2.6px 0 #282e35, 2.6px -2.4px 0 #282e35, 2.6px -1.4px 0 #282e35,
    2.6px -0.4px 0 #282e35, 2.6px 0.6px 0 #282e35, 2.6px 1.6px 0 #282e35,
    2.6px 2.6px 0 #282e35;
}
hr.style-seven {
  height: 7px;
  border: 18px dashed #999999a3;
  margin-bottom: 55px;
}
.hr-pattern {
  margin-top: 55px;
  height: 7px;
  border: 18px dashed #999999a3;
}
.feature-text {
  margin-top: 70px;
}
.emphasized {
  font-size: 30px;
  display: inline-block;
  position: relative;
  text-shadow: -2.4px -2.4px 0 #196090, -2.4px -1.4px 0 #196090,
    -2.4px -0.4px 0 #196090, -2.4px 0.6px 0 #196090, -2.4px 1.6px 0 #196090,
    -2.4px 2.6px 0 #196090, -1.4px -2.4px 0 #196090, -1.4px -1.4px 0 #196090,
    -1.4px -0.4px 0 #196090, -1.4px 0.6px 0 #196090, -1.4px 1.6px 0 #196090,
    -1.4px 2.6px 0 #196090, -0.4px -2.4px 0 #196090, -0.4px -1.4px 0 #196090,
    -0.4px -0.4px 0 #196090, -0.4px 0.6px 0 #196090, -0.4px 1.6px 0 #196090,
    -0.4px 2.6px 0 #196090, 0.6px -2.4px 0 #196090, 0.6px -1.4px 0 #196090,
    0.6px -0.4px 0 #196090, 0.6px 0.6px 0 #196090, 0.6px 1.6px 0 #196090,
    0.6px 2.6px 0 #196090, 1.6px -2.4px 0 #196090, 1.6px -1.4px 0 #196090,
    1.6px -0.4px 0 #196090, 1.6px 0.6px 0 #196090, 1.6px 1.6px 0 #196090,
    1.6px 2.6px 0 #196090, 2.6px -2.4px 0 #196090, 2.6px -1.4px 0 #196090,
    2.6px -0.4px 0 #196090, 2.6px 0.6px 0 #196090, 2.6px 1.6px 0 #196090,
    2.6px 2.6px 0 #196090;
}
@media only screen and (max-width: 450px) {
  .cta-title {
    font-size: 12px;
  }
}

.gem {
  max-width: 20% !important;
}

/* Smartphone Portrait and Landscape */
@media only screen and (min-device-width: 300px) and (max-device-width: 480px) {
  .notMobile {
    display: none;
  }
}
.mobileFeatures {
  display: none;
}

/* Smartphone Portrait and Landscape */
@media only screen and (min-device-width: 300px) and (max-device-width: 480px) {
  .mobileFeatures {
    display: inline;
  }
  .col-sm-2.col-xs-4 {
    text-align: center;
    margin-top: 27px;
  }
  .cta-title {
    font-size: 11px !important;
  }
  .icons {
    font-size: 30px !important;
  }
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .cta-title {
    font-size: 9px;
  }
}

@media only screen and (max-width: 620px) {
  ul.feature-list{
        padding-left: 24px;
  }
  .feature-video {
    width: 91%;
    padding: 10px;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
}
.feature-icon {
  text-align: center;
}
.col-lg-1,
.col-lg-10,
.col-lg-11,
.col-lg-12,
.col-lg-2,
.col-lg-3,
.col-lg-4,
.col-lg-5,
.col-lg-6,
.col-lg-7,
.col-lg-8,
.col-lg-9,
.col-md-1,
.col-md-10,
.col-md-11,
.col-md-12,
.col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-7,
.col-md-8,
.col-md-9,
.col-sm-1,
.col-sm-10,
.col-sm-11,
.col-sm-12,
.col-sm-2,
.col-sm-3,
.col-sm-4,
.col-sm-5,
.col-sm-6,
.col-sm-7,
.col-sm-8,
.col-sm-9,
.col-xs-1,
.col-xs-10,
.col-xs-11,
.col-xs-12,
.col-xs-2,
.col-xs-3,
.col-xs-4,
.col-xs-5,
.col-xs-6,
.col-xs-7,
.col-xs-8,
.col-xs-9 {
  position: relative;
  min-height: 1px;
  padding-left: 0px;
  padding-right: 0px;
}

@media only screen and (min-device-width: 300px) and (max-device-width: 580px) {
  ul.feature-list li img {
    max-width: 50px;
 }
 ul.feature-list li span {
    font-size: 15px;
  }
  ul.feature-list li{
    font-size: 13px;
  }
  img.story-image.troll {
    margin-left: -43px;
}
img.story-image.lever {
    margin-left: 10px !important;
}
img.story-image.slice {
    margin-left: 15px !important;
}
ul.feature-list {
    margin-top: 30px;
}
}

.gif-wrapper {
    display: flex;
        width: 72%;
    margin: auto;
}

.full-gif {
    width: 49%;
    height: 600px;
    display: inline-block;
}

.three-col {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    max-width: 1400px;
    margin: auto;
}

.three-col img {
    width: 33.3%;
    padding: 10px;
    object-fit: cover;
    max-width: 460px;
}

.all-gifs {
    flex-grow: 1;
    width: 50%;
    display: inline-block;
}
@media only screen and (max-width: 1200px) {
  .three-col img{
    width: 50%;
  }
  .gif-wrapper[data-v-7e9d4f02] {
    width: 95%;
  }
}
@media only screen and (max-width: 600px) {
  .three-col img{
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Home/Features2.vue